<div class="card-meeting-component">
  <Image type="image" borderRadius="radius" image="{{image}}" imageCloudinary="{{imageCloudinary}}" width="215px" mobileWidth="100%"></Image>
  <div>
    <ParagraphAtom [mobileSize]="15" align="center" color="dark" weight="semi-bold" size="large" text="{{localisation}}"></ParagraphAtom>
    <ParagraphAtom align="center" color="dark" weight="regular" size="intermediate" text="{{text}}"></ParagraphAtom>
  </div>
  <ButtonAtom size="default" color="yellow" [style]="'basic'" text="Prendre rendez-vous" icon="calendar-dark"></ButtonAtom>
</div>
